class ProductLifestyleImages {
  constructor() {
    this.slider = document.querySelector('[data-lifestyle-slider]');
    
    if (!this.slider) return;
    
    this.init();
  }
  
  init() {
    this.setupVideoHandlers();
  }
  
  // Removed navigation functionality - images display statically
  
  setupVideoHandlers() {
    const videoElements = this.slider.querySelectorAll('.lifestyle-video-element');
    const playButtons = this.slider.querySelectorAll('.lifestyle-video-play');
    
    playButtons.forEach((button, index) => {
      button.addEventListener('click', () => {
        const video = videoElements[index];
        if (video) {
          if (video.paused) {
            video.play();
            button.style.display = 'none';
          } else {
            video.pause();
            button.style.display = 'flex';
          }
        }
      });
    });
    
    videoElements.forEach((video) => {
      video.addEventListener('ended', () => {
        const playButton = video.parentElement.querySelector('.lifestyle-video-play');
        if (playButton) {
          playButton.style.display = 'flex';
        }
      });
    });
  }
  
  getItemsPerView() {
    const containerWidth = this.slider.parentElement.offsetWidth;
    
    if (containerWidth < 768) {
      return 1;
    } else if (containerWidth < 1024) {
      return 2;
    } else if (containerWidth < 1200) {
      return 3;
    } else {
      return 4;
    }
  }
  
  prev() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.updateSlider();
      this.updateNavigation();
    }
  }
  
  next() {
    if (this.currentIndex < this.maxIndex) {
      this.currentIndex++;
      this.updateSlider();
      this.updateNavigation();
    }
  }
  
  goToSlide(index) {
    this.currentIndex = Math.min(index, this.maxIndex);
    this.updateSlider();
    this.updateNavigation();
  }
  
  updateSlider() {
    const translateX = -this.currentIndex * (100 / this.itemsPerView);
    this.slider.style.transform = `translateX(${translateX}%)`;
  }
  
  updateNavigation() {
    // Update prev/next buttons
    if (this.prevBtn) {
      this.prevBtn.style.opacity = this.currentIndex === 0 ? '0.5' : '1';
      this.prevBtn.style.pointerEvents = this.currentIndex === 0 ? 'none' : 'auto';
    }
    
    if (this.nextBtn) {
      this.nextBtn.style.opacity = this.currentIndex >= this.maxIndex ? '0.5' : '1';
      this.nextBtn.style.pointerEvents = this.currentIndex >= this.maxIndex ? 'none' : 'auto';
    }
    
    // Update dots
    this.dots.forEach((dot, index) => {
      dot.classList.toggle('active', index === this.currentIndex);
    });
  }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new ProductLifestyleImages();
});

// Re-initialize on section load (for theme editor)
document.addEventListener('shopify:section:load', (event) => {
  if (event.target.querySelector('[data-lifestyle-slider]')) {
    new ProductLifestyleImages();
  }
});
